<div class="invoices-container">
    <app-invoices-cosmo-add [invoicesCosmo]="invoiceCosmo"></app-invoices-cosmo-add>
    <app-invoices-cosmo-list></app-invoices-cosmo-list>
</div>
